import { render, staticRenderFns } from "./SidebarAdmin.vue?vue&type=template&id=6cdd1ac4&scoped=true"
import script from "./SidebarAdmin.vue?vue&type=script&lang=js"
export * from "./SidebarAdmin.vue?vue&type=script&lang=js"
import style0 from "./SidebarAdmin.vue?vue&type=style&index=0&id=6cdd1ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdd1ac4",
  null
  
)

export default component.exports